import { render, staticRenderFns } from "./NutritionalPatientInfo.vue?vue&type=template&id=59e8970e&scoped=true&"
import script from "./NutritionalPatientInfo.vue?vue&type=script&lang=js&"
export * from "./NutritionalPatientInfo.vue?vue&type=script&lang=js&"
import style0 from "./NutritionalPatientInfo.vue?vue&type=style&index=0&id=59e8970e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8970e",
  null
  
)

export default component.exports